module.exports = __webpack_public_path__ + "img/highlights3-s.660a79ed.png";